import { RUN_OPTIONS, type LabFlags } from "@/lib/labServices";
import { Select } from "@/ui/Input";

import { LabBarField } from "./LabBarField";

const SHORT_LABELS: Record<string, string> = {
  safety_preview: "Safety",
  prompt_injection_v2: "Injection check",
};

/**
 * "Run options": the service features (liv-api, not the pack) chosen for ONE
 * run. They are sent as `labFlags` and are valid for that preview session only.
 */
export function LabRunOptions({
  value,
  onChange,
}: {
  value: LabFlags;
  onChange: (next: LabFlags) => void;
}) {
  return (
    <fieldset className="flex flex-wrap items-end gap-x-4 gap-y-3">
      <legend className="sr-only">
        Run options: service features for this run only, never written into
        the pack
      </legend>
      {RUN_OPTIONS.map((option) => {
        const current = value[option.name] ?? option.values[0].value;
        return (
          <LabBarField
            key={option.name}
            label={SHORT_LABELS[option.name] ?? option.label}
            description={option.values.find((v) => v.value === current)?.help}
            help={
              <>
                <p className="mb-2 text-muted-foreground">
                  For this run only; never written into the pack.
                </p>
                <ul className="space-y-1">
                  {option.values.map((v) => (
                    <li key={v.value}>
                      <span className="font-medium">{v.label}:</span> {v.help}
                    </li>
                  ))}
                </ul>
              </>
            }
          >
            {({ inputId, describedBy }) => (
              <Select
                id={inputId}
                className="w-28"
                aria-describedby={describedBy}
                value={current}
                onChange={(event) =>
                  onChange({ ...value, [option.name]: event.target.value })
                }
              >
                {option.values.map((v) => (
                  <option key={v.value} value={v.value}>
                    {v.label}
                  </option>
                ))}
              </Select>
            )}
          </LabBarField>
        );
      })}
    </fieldset>
  );
}
